import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";

const FileDropzone = ({
  oldFiles ,
  setFiles,
  updateOldImages,
  maxFiles = 5, // Default max files
  accept = "image/*", // Default accept all images
}) => {
  const [acceptedFiles, setAcceptedFiles] = useState([]);

  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    onDrop: (acceptedFilesList) => {
      // Check file limit
      if (acceptedFiles.length + acceptedFilesList.length > maxFiles) {
        alert(`You can only upload up to ${maxFiles} files`);
        return;
      }

      const filesWithPreviews = acceptedFilesList.map((file) => ({
        file,
        preview: file.type.startsWith("image/") 
          ? URL.createObjectURL(file) 
          : null, // Null for non-images
      }));

      setAcceptedFiles((prev) => [...prev, ...filesWithPreviews]);
      setFiles((prev) => [...prev, ...acceptedFilesList]);
    },
    multiple: true,
    accept, // Use prop value
    maxFiles, // Use prop value
  });

  // Clean up object URLs
  useEffect(() => {
    return () => {
      acceptedFiles.forEach((file) => {
        if (file.preview) URL.revokeObjectURL(file.preview);
      });
    };
  }, [acceptedFiles]);

  const removeFile = (index) => {
    const updatedFiles = [...acceptedFiles];
    URL.revokeObjectURL(updatedFiles[index].preview); // Cleanup
    updatedFiles.splice(index, 1);
    setAcceptedFiles(updatedFiles);
    setFiles(updatedFiles.map((f) => f.file));
  };

  const removeDBFile = (nameToRemove) => {
    const updatedOldImages = oldFiles.filter((image) => image !== nameToRemove);
    updateOldImages(updatedOldImages);
  };

  // File type icon renderer
  const renderFilePreview = (file) => {
    if (file.preview) {
      return <img src={file.preview} alt="Preview" className="preview-image" />;
    } else {
      return (
        <div className="file-icon">
          <i className="bi bi-file-pdf fs-1"></i>
          <span>{file.file.name}</span>
        </div>
      );
    }
  };

  return (
    <div className="dropzone-container">
      <div {...getRootProps()} className={`dropzone ${isDragActive ? "active" : ""}`}>
        <input {...getInputProps()} />
        <p>
          {isDragActive
            ? "Drop the files here..."
            : `Drag 'n' drop files here (Max ${maxFiles}), or click to select`}
        </p>
        <button type="button"  className="btn btn-sm btn-base">
          Select Files
        </button>
      </div>

      <div className="previews-container">
        {/* Old files (from DB) */}
        {oldFiles.map((image, index) => (
          <div key={`old-${index}`} className="preview-item">
            {typeof image === 'string' && image.match(/\.(jpeg|jpg|gif|png)$/)  ? (
              <img src={image} alt="Preview" className="preview-image" />
            ) : (
              <a className="file-icon text-primary" href={image} target="_blank" >
                <i className="bi bi-file-pdf fs-1"></i>
                <span>{image.split('/').pop()}</span>
              </a>
            )}
            <button onClick={() => removeDBFile(image)}  type="button" className="remove-button">
              <i className="bi  bi-x-lg fw-bold text-white"></i>
            </button>
          </div>
        ))}

        {/* Newly added files */}
        {acceptedFiles.map((file, index) => (
          <div key={`new-${index}`} className="preview-item">
            {renderFilePreview(file)}
            <button onClick={() => removeFile(index)} type="button" className="remove-button">
                <i className="bi  bi-x-lg fw-bold text-white"></i>
            </button>
          </div>
        ))}
      </div>

  
    </div>
  );
};

export default FileDropzone;